const { zopimInit } = require('./zopim-init')
const { zopimOpen } = require('./zopim-open')

module.exports = {
  zopimInit,
  zopimOpen
}
